import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import DashboardList from "@/pages/DashboardList";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import CalendarView from "@/pages/CalendarView";
import Reminders from "@/pages/Reminders";
import PublicSign from "@/pages/PublicSign";
import PublicEkyc from "@/pages/PublicEkyc";
import PublicCdd from "@/pages/PublicCdd";
import CompaniesByFYE from "@/pages/CompaniesByFYE";
import ResolutionTemplates from "@/pages/ResolutionTemplates";
import TaxCompliance from "@/pages/TaxCompliance";
import AuditClients from "@/pages/AuditClients";
import AccessTokens from "@/pages/AccessTokens";
import Users from "@/pages/Users";
import ResetPassword from "@/pages/ResetPassword";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-8 font-mono text-xs text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset/:token" element={<ResetPassword />} />
            <Route path="/sign/:token" element={<PublicSign />} />
            <Route path="/ekyc/:token" element={<PublicEkyc />} />
            <Route path="/cdd/:token" element={<PublicCdd />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard/deadlines" element={<DashboardList />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/companies-by-fye" element={<CompaniesByFYE />} />
              <Route path="/templates" element={<ResolutionTemplates />} />
              <Route path="/tax" element={<TaxCompliance />} />
              <Route path="/audit" element={<AuditClients />} />
              <Route path="/access-tokens" element={<AccessTokens />} />
              <Route path="/calendar" element={<CalendarView />} />
              <Route path="/reminders" element={<Reminders />} />
              <Route path="/users" element={<Users />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
